export enum ShopActionTypes {

    GetAllShopItems = "[Shop Component] Get all shop items",
    GetAllShopItemsSuccess = "[Shop Component] Get all shop items success",

    AddShopItemToCart = "[Shop Component] Set shop item amount",
    RemoveShopItemFromCart = "[Shop Component] Remove shop item from cart",
    DecreaseShopItemAmount = "[Shop Component] Decrease shop item amount",

    SubmitOrderRequest = "[Shop Component] Submit order request",
    SubmitOrderRequestSuccess = "[Shop Component] Submit order request success",
    SubmitOrderRequestFailed = "[Shop Component] Submit order request failed",
}